angular.module('ui.order.orderItemCard.orderItemFiles', [
    'ui.order.orderItemCard.orderItemFiles.fileUpload',
    'ui.order.orderItemCard.orderItemFiles.dataSizeFilter',
    'ui.order.orderItemCard.orderItemFiles.fileService',
    'ui.order.orderItemCard.orderItemFiles.checkDuplicatesService'
])

    .directive('orderItemFiles', function () {
        return {
            restrict: 'E',
            scope: {},
            templateUrl: 'app/ui/order/orderItemCard/orderItemFiles/orderItemFiles.html',
            controller: 'OrderItemFilesController'
        };
    })

    .controller('OrderItemFilesController', function ($scope, toastr, $document,
                                                      orderItemsRepository, authService,
                                                      checkDuplicatesService, filesControllerUpdatesService,
                                                      orderItemCardDataProvider, $http, $log) {
        $scope.baseUrl = om.config.build.baseUrl;

        $scope.currentPage = 0;
        $scope.pageSize = 15;

        $scope.validate = validate;
        $scope.getDocument = getDocument;
        $scope.numberOfPages = numberOfPages;
        $scope.someFileUploaded = someFileUploaded;

        checkDuplicatesService.getAlreadyUploadedFiles = function () {
            return $scope.documents;
        };

        filesControllerUpdatesService.onNewDocument(function () {
            refreshDocList();
        });

        orderItemCardDataProvider.onDataChange('OrderItemFilesController', function () {
            if ($scope.orderItemId === orderItemCardDataProvider.getOrderItemId()) {
                return;
            }
            $scope.orderItemId = orderItemCardDataProvider.getOrderItemId();
            refreshDocList();
        });

        initController();

        function initController() {
            refreshDocList();
        }

        function numberOfPages() {
            var length = $scope.documents ? $scope.documents.length : 0;
            return Math.ceil(length / $scope.pageSize);
        }

        function getDocument(documentId) {

            var form = document.createElement("form");
            form.method = "POST";
            form.action = om.config.build.baseUrl + "/documents/" + documentId + "/download";
            form.setAttribute("style", "display:none");

            var input = document.createElement("input");
            input.setAttribute("name", "Authorization");
            input.setAttribute("value", authService.getToken());
            form.appendChild(input);
            form.submit();
        }

        function someFileUploaded() {
            refreshDocList();
        }

        function validate() {
            return true;
        }

        function refreshDocList() {
            var orderItem = orderItemCardDataProvider.getOrderItem();
            if (!orderItem) {
                $scope.documents = null;
                return;
            }

            return orderItemsRepository.getDocuments(orderItem)
                .then(
                function (documents) {
                    $scope.documents = documents;
                    return documents;
                },
                function (error) {
                    toastr.error(error.message, "Can't load documents");
                    $log.error("Can't load documents of orderItem `%s`. Cause: %s", $scope.orderItemId, error.message);
                });
        }
    })

    // Separate service for update events (to prevent multiple event subscription)
    .service('filesControllerUpdatesService', function (rest) {
        var _this = this;
        var callback;

        rest.events.on("modelCreatedOnServer", function (modelInfo) {
            if (!callback) {
                return;
            }
            if (modelInfo && modelInfo.modelType == "DocumentModel") {
                callback(modelInfo);
            }
        });

        _this.onNewDocument = function (cb) {
            callback = cb;
        };

        return _this;
    })

    .filter('startFrom', function () {
        return function (input, start) {
            if (!input || !input.length) {
                return;
            }
            start = +start; //parse to int
            return input.slice(start);
        }
    })

;